export default __webpack_public_path__ + "static/media/CardLogoUnknown.bd29dedb.svg";